<script>
  import assignIn from 'lodash/assignIn'
  import map from 'lodash/map'
  import slice from 'lodash/slice'
  import floor from 'lodash/floor'
  import get from 'lodash/get'
  import isUndefined from 'lodash/isUndefined'
  import forEach from 'lodash/forEach'
  import isEmpty from 'lodash/isEmpty'
  import { isDesktop, isDomElement } from 'mixins/utilities'
  import animationHandler from 'components/mixins/animationHandler'
  import { ResizeObserver } from 'vue-resize'

  export default{
    props: {
      sliderOptions: {
        type: Object,
        default() {
          return this.getDefault()
        },
      },
      extraSlots: {
        type: Array,
      },
      selector: {
        type: String,
      },
    },
    mixins: [animationHandler],
    data: () => ({
      sliderId: {},
      currentSlide: 0,
      numOfSlide: 0,
      sliderOptionsData: {},
      sliderInfos: {},
      allowSlide: true,
      zoom: false,
      articleLimit: 3,
      preventSwipe: false,
      resetPreventSwipe: false,
      slideChangeEndResponse: {},
      isAnimating: false,
      leftStartingX: 0,
    }),
    computed: {
    },
    components: {
      ResizeObserver,
    },
    mounted() {
      this.sliderOptionsData = assignIn(this.getDefault(), this.sliderOptions)
      const self = this
      self.sliderInfos.activeSlide = 0
      if (this.sliderOptions.initFromMount) {
        self.init()
      }
    },
    updated() {
      if (get(this, '$refs.container.childElementCount')) {
        this.sliderInfos.slideCount = this.$refs.container.childElementCount
      }
    },
    render(h) {
      const renderH = []
      this.numOfSlide = this.$slots.default ? this.$slots.default.length : 0
      renderH.push(h('div', {
        class: {slider: true}, style: {width: this.$slots.default ? `${this.$slots.default.length * 100}%` : 0}, ref: 'container',
      }, this.$slots.default))
      renderH.push(this.$slots.caption)
      if (this.$slots.prev) {
        renderH.push(h('div', {
          on: {
            click: this.prev,
          },
        }, this.$slots.prev))
      }

      if (this.$slots.next) {
        renderH.push(h('div', {
          on: {
            click: this.next,
          },
        }, this.$slots.next))
      }

      if (this.extraSlots) {
        forEach(this.extraSlots, (extraSlot) => {
          const key = get(extraSlot, 'key', false)

          if (key && this.$slots[key]) {
            const renderClass = {}
            renderClass[key] = true

            renderH.push(h('div', {
              class: renderClass,
              ref: key,
            }, this.$slots[key]))
          }
        })
      }

      if (this.$slots.pagination) {
        const activeSlide = this.sliderInfos.activeSlide
        const limit = this.sliderOptions.articleLimit || 10
        const page = floor(activeSlide / limit)

        const dots = map(slice(this.$slots.default, page * limit, (page + 1) * limit), (item, key) => h('div', {
          class: {
            'is-active': key === activeSlide % limit,
          },
          on: {
            click: () => {
              if (isDesktop()) this.goTo((page * limit) + key, false)
            },
          },
        }, item.name))

        renderH.push(h('div', {
          class: {'slider-pagination': true},
          ref: 'pagination',
        }, dots))
      }

      renderH.push(h('resize-observer', {
        on: {
          notify: this.handleResize,
        },
      }, ''))

      return h('div', {
        class: {carousel: true, 'has-slider': true},
      }, renderH)
    },
    methods: {
      toggleContainerAnimation(isOn) {
        const containerAnimationClass = 'is-animating'
        const animationElements = [this.$refs.container, ...this.getExtraSlotAnimationElements()]
        forEach(animationElements, (element) => {
          if (isOn) {
            element.classList.add(containerAnimationClass)
          } else {
            element.classList.remove(containerAnimationClass)
          }
        })
      },
      updateExtraSlotsPositionX(value, isHide) {
        const extraSlotAnimationElements = this.getExtraSlotAnimationElements()
        if (!isEmpty(extraSlotAnimationElements)) {
          const startingLeftX = window.innerWidth * this.sliderInfos.activeSlide * -1
          forEach(extraSlotAnimationElements, (element) => {
            if (value === (startingLeftX) || value === 0) {
              if (isHide) {
                element.style['transition-duration'] = ''
                if (this.sliderInfos.currentSlide > this.sliderInfos.activeSlide) {
                  element.style.transform = 'translateX( 100vw )'
                } else {
                  element.style.transform = 'translateX( -100vw )'
                }
              } else {
                element.style['transition-duration'] = ''
                element.style.transform = 'translateX( 0px )'
              }
            } else {
              element.style['transition-duration'] = '0s'
              element.style.transform = `translateX( ${value - startingLeftX}px )`
            }
          })
        }
      },
      updateContainerPositionX(value) {
        this.$refs.container.style.transform = `translateX( ${value}px )`
      },
      getExtraSlotAnimationElements() {
        const result = []
        if (this.extraSlots) {
          forEach(this.extraSlots, (extraSlot) => {
            const key = get(extraSlot, 'key', false)
            const animationClass = get(extraSlot, 'animationClass', false)
            const targetElement = get(this, `$refs[${key}]`, false)
            if (targetElement) {
              const animationElement = targetElement.querySelector(`.${animationClass}`)
              if (key && animationClass && animationElement) {
                result.push(animationElement)
              }
            }
          })
        }
        return result
      },
      getWidth() {
        let w = get(this, '$refs.container.offsetParent')
        // getBoundingClientRect() return width / height with decimal, offsetWidth only integer
        w = w ? w.getBoundingClientRect().width : window.innerWidth
        return w
      },
      handleResize() {
        const moveX = -(this.getWidth()) * this.sliderInfos.activeSlide
        this.updateContainerPositionX(moveX)
        this.updateExtraSlotsPositionX(moveX)
      },
      getDefault() {
        return {
          width: '100%',
          allowScroll: true,
          realTimeAnimate: false,
          sensitivity: 25,
          exactAngle: [],
          tapToHideCaption: false,
          tapToHideTitle: false,
          childProcessed: false,
          forceStop: false,
          disableSwipe: false,
          initFromMount: false,
          isPhotoSlider: false,
        }
      },
      init() {
        this.bindAnimation(this.$refs.container, [this.slideAnimationEnd])
        const self = this
        self.sliderInfos.Hammer = require('hammerjs')
        self.sliderInfos.sliderPanelSelector = '.slider-panel'
        self.sliderInfos.sensitivity = self.sliderOptions.sensitivity
        self.sliderInfos.slideCount = 0
        self.sliderInfos.currentSlide = 0
        self.sliderInfos.percentage = ''
        self.sliderInfos.slideCount = self.$refs.container.childElementCount
        self.$refs.container.style.width = `${self.sliderInfos.slideCount * 100}%`
        const sliderManager = new self.sliderInfos.Hammer.Manager(self.$refs.container, {
          touchAction: 'pan-y',
          recognizers: [
            [self.sliderInfos.Hammer.Pan, { direction: self.sliderInfos.Hammer.DIRECTION_ALL }],
            [self.sliderInfos.Hammer.Tap],
          ],
        })
        sliderManager.add(new self.sliderInfos.Hammer.Pan({ threshold: 0, pointers: 0 }))
        sliderManager.on('panend', (e) => {
          if (this.closest(e.target, '.no-article-swipe', 'body') !== null) {
            return
          }
          if (!isUndefined(self.sliderOptions.disableSwipe) && self.sliderOptions.disableSwipe === true) {
            return
          }
          if (!isUndefined(self.sliderOptions.forceStop) && self.sliderOptions.forceStop) {
            return
          }
          if (!isUndefined(self.sliderOptions.childScrolling) && self.sliderOptions.childScrolling) {
            return
          }
          if (!self.sliderInfos.percentage) {
            return
          }

          if (self.sliderOptionsData.velocityX) {
            if (Math.abs(e.velocityX) < self.sliderOptionsData.velocityX) {
              self.sliderInfos.goTo(self.sliderInfos.activeSlide)
              return
            }
          }
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && (Math.abs(e.deltaX / window.innerWidth) * 100 > self.sliderInfos.sensitivity)) {
            if (e.velocityX > 1) {
              self.goTo(self.sliderInfos.activeSlide - 1)
            } else if (e.velocityX < -1) {
              self.goTo(self.sliderInfos.activeSlide + 1)
            } else if (self.sliderInfos.percentage <= -(self.sliderInfos.sensitivity / self.sliderInfos.slideCount)) {
              self.goTo(self.sliderInfos.activeSlide + 1)
            } else if (self.sliderInfos.percentage >= (self.sliderInfos.sensitivity / self.sliderInfos.slideCount)) {
              self.goTo(self.sliderInfos.activeSlide - 1)
            } else {
              self.goTo(self.sliderInfos.activeSlide)
            }
          } else if (!self.sliderOptions.childScrolling) {
            self.goTo(self.sliderInfos.activeSlide)
          }
          self.sliderInfos.percentage = false
        })

        sliderManager.on('panstart', (e) => {
          if (this.closest(e.target, '.no-article-swipe', 'body') !== null) {
            return
          }
          if (!isUndefined(self.sliderOptions.disableSwipe) && self.sliderOptions.disableSwipe === true) {
            return
          }
          if (!isUndefined(self.sliderOptions.forceStop) && self.sliderOptions.forceStop) {
            return
          }
          if (!isUndefined(self.sliderOptions.childScrolling) && self.sliderOptions.childScrolling) {
            return
          }
          if (this.resetPreventSwipe) {
            this.preventSwipe = false
            this.resetPreventSwipe = false
          }
        })

        sliderManager.on('pan', (e) => {
          if (this.preventSwipe && !this.sliderOptions.isPhotoSlider) return
          if (this.closest(e.target, '.no-article-swipe', 'body') !== null) {
            return
          }
          if (!isUndefined(self.sliderOptions.disableSwipe) && self.sliderOptions.disableSwipe === true) {
            return
          }
          if (!isUndefined(self.sliderOptions.childProcessed) && !self.sliderOptions.childProcessed) {
            return
          }
          if (!isUndefined(self.sliderOptions.forceStop) && self.sliderOptions.forceStop) {
            return
          }
          if (this.zoom) return
          if (!self.sliderOptions.childScrolling) {
            self.sliderInfos.percentage = (100 / self.sliderInfos.slideCount) * (e.deltaX / window.innerWidth)
            if (self.sliderOptionsData.realTimeAnimate) {
              let moveX = (this.leftStartingX - e.deltaX)

              if (self.sliderInfos.activeSlide === 0 && moveX < 0) moveX = 0


              self.updateContainerPositionX(moveX * -1)
              self.updateExtraSlotsPositionX(moveX * -1)
              this.$emit('slideProgress', {
                additionalEvent: e.additionalEvent || false,
                deltaX: e.deltaX,
                deltaY: e.deltaY,
                angle: e.angle,
                isFinal: e.isFinal,
                isFirst: e.isFirst,
              })
            }
          }
          this.updateIsAnimating()
        })


        self.sliderInfos.goTo = function(number, animation = true) {
          self.goTo(number, animation)
        }
      },
      slideChangeEnd() {
        this.resetPreventSwipe = true
        if (get(this, 'slideChangeEndResponse.change')) this.updateExtraSlotsPositionX(0)
        this.$emit('slideChangeEnd', {
          response: this.slideChangeEndResponse,
        }, {ps: 'on event slideChangeEnd'})
        this.slideChangeEndResponse = false
        this.leftStartingX = window.innerWidth * this.sliderInfos.activeSlide
        this.updateIsAnimating(false)
      },
      prev(animation = true) {
        if (this.sliderInfos.activeSlide > 0) {
          this.sliderInfos.activeSlide -= 1
        }
        this.goTo(this.sliderInfos.activeSlide, animation)
      },
      next(animation = true) {
        if (this.sliderInfos.activeSlide < (this.numOfSlide - 1)) {
          this.sliderInfos.activeSlide += 1
        }
        this.goTo(this.sliderInfos.activeSlide, animation)
      },
      goTo(number, animation = true) {
        if (this.zoom) return
        const slideBeforeGoto = this.sliderInfos.currentSlide
        if (number < 0) {
          this.sliderInfos.activeSlide = 0
        } else if (number > this.sliderInfos.slideCount - 1) {
          this.sliderInfos.activeSlide = this.sliderInfos.slideCount - 1
        } else {
          this.sliderInfos.activeSlide = number
        }
        if (animation) {
          this.updateIsAnimating(true)
        }
        let slideBehavior = false
        if (this.sliderInfos.activeSlide > slideBeforeGoto) {
          slideBehavior = 'next'
        } else if (this.sliderInfos.activeSlide < slideBeforeGoto) {
          slideBehavior = 'prev'
        }
        if (isDomElement(this.$refs.container)) {
          const moveX = -(this.getWidth()) * this.sliderInfos.activeSlide
          this.updateContainerPositionX(moveX)
          this.updateExtraSlotsPositionX(moveX, slideBehavior)
        }
        this.$emit('slideChangeStart', {
          response: {
            beforeSlide: slideBeforeGoto,
            activeSlide: this.sliderInfos.activeSlide,
            slideCount: this.sliderInfos.slideCount,
            change: slideBeforeGoto !== this.sliderInfos.activeSlide,
            behavior: slideBehavior,
          },
        }, {ps: 'on event slideChangeStart'})

        this.slideChangeEndResponse = {
          beforeSlide: slideBeforeGoto,
          activeSlide: this.sliderInfos.activeSlide,
          slideCount: this.sliderInfos.slideCount,
          change: slideBeforeGoto !== this.sliderInfos.activeSlide,
          behavior: slideBehavior,
        }
        if (!animation) {
          this.slideChangeEnd()
        }
        this.sliderInfos.currentSlide = this.sliderInfos.activeSlide
      },
      updateSlideCount(count) {
        this.sliderInfos.slideCount = count || this.$refs.container.childElementCount
      },
      updateIsAnimating(value) {
        if (isDomElement(this.$refs.container)) {
          if (!isUndefined(value)) {
            if (value) {
              this.toggleContainerAnimation(true)
              if (!this.preventSwipe && !this.resetPreventSwipe && !this.sliderOptions.isPhotoSlider && this.$refs.container.getBoundingClientRect().left !== (-1 * this.leftStartingX)) {
                this.preventSwipe = true
              }
            } else {
              this.toggleContainerAnimation(false)
              this.preventSwipe = false
            }
            this.isAnimating = value
          } else if (this.$refs.container.getBoundingClientRect().left === (-1 * this.leftStartingX)) {
            this.toggleContainerAnimation(false)
            this.preventSwipe = false
            this.leftStartingX = window.innerWidth * this.sliderInfos.activeSlide
            this.isAnimating = false
          }
        }
      },
      closest(el, selector, stopSelector) {
        let retval = null
        if (isDomElement(el)) {
          while (el) {
            if (el.matches(selector)) {
              retval = el
              break
            } else if (stopSelector && el.matches(stopSelector)) {
              break
            }
            el = el.parentElement
          }
        }
        return retval
      },
      slideAnimationEnd(ele) {
        if (ele.className.match(/slider/)) {
          this.slideChangeEnd()
        }
      },
    },
  }
</script>

<style lang="scss">
  .carousel{width:100%;}
  .slider-panel{ width:100%; position:relative; overflow: hidden;}
  img{width:100%; height:auto}

  .has-slider {
    overflow: hidden;
    position: relative;
    width: 100%;
    .slider {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
    }
    .is-animating {
      -webkit-transition: -webkit-transform 400ms;
      transition: -webkit-transform 400ms;
      transition: transform 400ms;
      transition: transform 400ms;
    }
    .slider-pagination{
      // pointer-events: none;
      text-align: center;
      width: 100%;
      display: inline-block;
      > * {
        cursor: pointer;
        border-radius: 50%;
        box-shadow: 0 0 0 2px black;
        display: inline-block;
        height: 6px;
        margin-left: 4px;
        margin-right: 4px;
        -webkit-transition: opacity 250ms;
        transition: opacity 250ms;
        width: 6px;
        background: $black;
        opacity: 0;
        &.is-active{
          opacity: 0.75;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CusCarousel.vue?089f4e50